import { CardContent, Grid } from '@mui/material';

import { Card, InfoField, LinkChip } from '@occc-app/design-system';
import { PointChangeViewItemDataOffer } from '@occc-app/routes/Transactions/PointChangeView/types';

type Props = {
  id: string;
  amount: number;
  time: string;
  awardedBy?: string;
  award?: PointChangeViewItemDataOffer;
  adjustmentReason?: string;
  notes?: string;
  source?: string;
  donationAmount?: string;
};

export const PointChangeViewHeader = (props: Props) => {
  const {
    id,
    amount,
    time,
    awardedBy,
    adjustmentReason,
    source,
    award,
    notes = '-',
    donationAmount,
  } = props;

  return (
    <Card
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={4}>
            <InfoField label='Point Change Amount' value={amount} />
          </Grid>

          <Grid item md={4}>
            <InfoField label='Timestamp' value={time} />
          </Grid>

          <Grid item md={4}>
            <InfoField label='Point Change ID' value={id} />
          </Grid>

          {award ? (
            <Grid item md={4}>
              <InfoField
                label='Award Granted'
                value={
                  <>
                    <LinkChip
                      key={award.id}
                      label={award.name}
                      tooltip={award.title}
                      href={award.url}
                    />
                  </>
                }
              />
            </Grid>
          ) : null}

          {adjustmentReason && (
            <Grid item md={4}>
              <InfoField label='Adjustment Reason' value={adjustmentReason} />
            </Grid>
          )}

          {awardedBy && (
            <Grid item md={4}>
              <InfoField label='Points Awarded By' value={awardedBy} />
            </Grid>
          )}

          {donationAmount && (
            <Grid item md={4}>
              <InfoField label='Donation Amount' value={donationAmount} />
            </Grid>
          )}

          <Grid item md={4}>
            <InfoField label='Note' value={notes} />
          </Grid>

          {source && (
            <Grid item md={4}>
              <InfoField label='Source' value={source} />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
